import React, { memo } from "react";

import { ListItemType } from "../types";

const ListItem: React.FC<ListItemType> = ({ perex, title, url, target }) => {
  if (!title || !url) return null;

  return (
    <li className="block border-b border-grey-30 first:border-t" data-testid={`result-item-${url}`}>
      <a className="group block break-words py-6 px-4" href={url} target={target}>
        <div className="font-semibold leading-7 underline media-group-hover:text-red-corporate media-group-hover:decoration-red-corporate sm:duration-300">
          {title}
        </div>

        {/* eslint-disable-next-line react/no-danger */}
        {perex && <div className="mt-2 text-xs" dangerouslySetInnerHTML={{ __html: perex }} />}
      </a>
    </li>
  );
};

export default memo(ListItem);
